<template>
  <div class="intro-autocloud-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <common-advantage :advantages="valuesList"></common-advantage>
    <common-advantage :advantages="advantageList"></common-advantage>
    <!-- <common-advantage :advantages="productsList"></common-advantage> -->
    <div class="application-wrap autoclound-app">
      <div class="application-title">
        <span class="line lline"><i /><i /></span>
        <span class="word">云平台产品</span>
        <span class="line rline"><i /><i /></span>
      </div>
      <ul class="tabs-filter">
        <li class="tab-filter-item" v-for="(item, index) in tabsfilter" :key="index" @click="toggleTabs(index)" :class="{active:index===currentTabIndex}">
          <i class="tabicon" :class="'icon' + index"></i>
          <span>{{ item }}</span>
        </li>
      </ul>
      <div class="tabs-content">
        <div v-for="(item, index) in productsList" :key="index">
          <div class="content-item" v-show="currentTabIndex === index">
            <common-advantage :advantages="productsList[index]" :planeStyle="true"></common-advantage>
          </div>
        </div>
      </div>
    </div>
    <div class="application-wrap">
      <div class="application-title">
        <span class="line lline"><i /><i /></span>
        <span class="word">应用案例</span>
        <span class="line rline"><i /><i /></span>
      </div>
      <ul class="application-list">
        <li class="application-list-item" v-for="(app, index) in appListData" :key="index" @mouseover="hoverIndex = index" @mouseout="hoverIndex = -1">
          <div class="inner">
            <p class="app-icon-wrap">
              <span class="app-icon" :class="'app-icon' + app.key"></span>
            </p>
            <p class="app-name">{{ app.name }}</p>
            <p class="app-intro">{{ app.intro }}</p>
          </div>
        </li>
      </ul>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage
  },
  data () {
    return {
      tabsfilter: ['热门', '计算与存储', '数据库', '中间件', '网络', '视频', '安全', '开发与运维'],
      currentTabIndex: 0,
      hoverIndex: -1,
      valuesList: {
        title: '云平台价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '极大简化系统接入搭建工作',
            desc: '提供统一的系统运行环境，将开发人员从冗长繁琐的环境准备过程中解放出来，使其能够专注于业务本身的研发工作。',
            iconname: 'icon-cloud-01'
          },
          {
            key: '1',
            title: '降低IT运营成本',
            desc: '业务云化后，将为企业节约大量的IT软件硬件采购成本，节约传统服务器运维、DBA、网络运维等人力成本。',
            iconname: 'icon-cloud-02'
          },
          {
            key: '2',
            title: '提供稳定高可用的云服务',
            desc: '之家云已服务包含汽车之家主站、APP等1000余个线上系统，2019年度，网站稳定性达99.997%，容器集群SLA：99.99%，Hadoop核心SLA：100%。',
            iconname: 'icon-cloud-03'
          }
        ]
      },
      advantageList: {
        title: '云平台优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '全栈云服务',
            desc: '完美支持容器及物理机虚机发布模式，配套功能强大易于使用的日志、监控、网关、负载等子系统，为研发人员提供稳定便捷的研发基础设施。',
            iconname: 'icon-cloud-04'
          },
          {
            key: '1',
            title: '企业级用户优化',
            desc: '之家云产品设计立足于企业级用户，面向组织内不同角色身份成员，通过友好的使用引导及丰富的解释说明，打造全员可用立即上手的云服务产品。',
            iconname: 'icon-cloud-05'
          },
          {
            key: '2',
            title: '汽车之家AI服务',
            desc: '之家云中现以通过API接口方式，对外提供汽车之家AI服务，如：车辆识别、文字识别、人脸识别、语音识别等汽车行业AI服务。',
            iconname: 'icon-cloud-06'
          },
          {
            key: '3',
            title: '灵活的资源使用策略',
            desc: '用户可根据业务资源需求情况，便捷的随时调整使用的之家云资源，包括实例数、CPU、内存、存储空间等等。',
            iconname: 'icon-cloud-07'
          }
        ]
      },
      appListData: [
        {
          key: '0',
          name: '之家云',
          intro: '目前之家云平台已整体实现云化部署，平台网站稳定性达99.997%，在汽车之家818活动及其他节日活动期间，提供稳定的支持'
        },
        {
          key: '1',
          name: '汽车之家APP',
          intro: '作为汽车之家最核心应用之一，汽车之家APP所包含的海量子系统正在逐步切换至之家云，利用云平台提升管理效率降低运营成本'
        },
        {
          key: '2',
          name: '平安智慧交通',
          intro: '利用汽车之家AI图像识别技术，实现对视频车辆车系AI自动识别功能，该服务已上线之家云'
        }
      ],
      productsList: [
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '容器云AutoDocker',
              desc: '基于Kubernetes的集群全托管服务，拥有之家创新的双活子集群架构，支持暴露IP、固定IP、本地存储等高级特性，为客户提供高可靠、功能强大的容器管理服务'
            },
            {
              key: '1',
              title: '云数据库MySQL',
              desc: '专业化的高性能,高可靠MySQL数据库服务,完善可靠的数据备份和恢复,完备的安全管理, 高效完善的监控, 提供多维度状态、性能、查询等数据的可视化等功能'
            },
            {
              key: '2',
              title: '云监控AutoCMP',
              desc: '为用户提供全方位的基础数据监控，无需配置，即可查看云服务器的性能视图及告警记录，实时掌握资源使用情况，保证应用稳定运行'
            },
            {
              key: '3',
              title: '镜像中心',
              desc: '提供安全、可靠、易用的公共镜像，以及便捷的私有镜像生命周期管理'
            },
            {
              key: '4',
              title: '对象存储',
              desc: '安全稳定、海量、便捷、低延迟、低成本，高性能的云端存储服务，大规模应用于汽车之家VR车展等核心业务'
            },
            {
              key: '5',
              title: '域名及负载AutoLB',
              desc: '将访问流量自动分发到多台云服务器、容器集群上，扩展应用系统对外的服务能力，实现更高水平的应用容错'
            },
            {
              key: '6',
              title: 'APIGateway',
              desc: '为开发者提供的高性能、高可用、高安全的API托管服务'
            },
            {
              key: '7',
              title: 'Redis',
              desc: '提供分布式 Redis 解决方案及主从版 Redis解决方案，支持故障自动迁移，数据安全可靠'
            },
            {
              key: '8',
              title: '接口测试',
              desc: '零编码，通过配置即可进行接口测试测试数据统一维护'
            },
            {
              key: '9',
              title: '应用中心A-One',
              desc: '引入敏捷研发、持续集成、持续交付、DevOps等理念、支持公有云、私有云和混合云的一站式研发协同平台'
            },
            {
              key: '10',
              title: '切图系统',
              desc: '切图系统（Dynamic Image System）用户根据配置不同url规则，切图系统实时动态的缩放不同规格的图片，全面提升海量图片的处理能力'
            },
            {
              key: '11',
              title: 'RabbitMQ',
              desc: '云上消息队列服务，支持广播、事务消息、消息路由、死信队列、优先级队列等特性，广泛应用于秒杀、流控、系统解耦等场景'
            },
            {
              key: '12',
              title: 'CDN',
              desc: '内容分发网络（CDN）将源站内容分发至靠近用户的加速节点，使用户可以就近获得所需的内容，解决Internet网络拥挤的状况，提高用户访问的响应速度和成功率，从而提升您业务的使用体验'
            },
            {
              key: '13',
              title: '云日志AutoLog',
              desc: '云日志AutoLog是一款为之家日志类数据提供的一站式服务平台。提供日志采集、历史日志查询、实时日志订阅、日志分析与监控等功能，帮助用户轻松应对日志类数据的监控、运营、运维等场景'
            },
            {
              key: '14',
              title: '性能测试',
              desc: '基于应用的性能测试能够将应用和性能测试绑定，形成基于应用的性能测试流水，同时性能测试基于容器的压力端水平伸缩架构，可模拟海量用户以及基于线上流量等真实的业务场景大容量、多协议、高并发压力测试'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '容器云AutoDocker',
              desc: '基于Kubernetes的集群全托管服务，拥有之家创新的双活子集群架构，支持暴露IP、固定IP、本地存储等高级特性，为客户提供高可靠、功能强大的容器管理服务'
            },
            {
              key: '1',
              title: '云服务器',
              desc: '可根据预算自助申请、根据数十种不同使用类型自动初始化的云服务器，帮助客户打造可靠、安全、灵活、高效的应用环境'
            },
            {
              key: '2',
              title: '文件存储',
              desc: '安全可靠，集成化、容量可扩展的低成本共享文件存储服务'
            },
            {
              key: '3',
              title: '镜像中心',
              desc: '提供安全、可靠、易用的公共镜像，以及便捷的私有镜像生命周期管理'
            },
            {
              key: '4',
              title: '对象存储',
              desc: '安全稳定、海量、便捷、低延迟、低成本，高性能的云端存储服务，大规模应用于汽车之家VR车展等核心业务'
            },
            {
              key: '5',
              title: '块存储',
              desc: '稳定可靠、低延迟、可扩展的持久性块存储设备，可作为云服务器与容器云的独立硬盘使用'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '云数据库TiDB',
              desc: '基于TiDB 的一款同时支持联机事务处理（OLTP）和 联机分析处理（OLAP）分布式数据库，具有自动的水平伸缩、强一致性的分布式事务、故障自恢复、兼容 MySQL协议等种种优点，适合海量数据量的在线交易和实时分析业务'
            },
            {
              key: '1',
              title: '云数据库MySQL',
              desc: '专业化的高性能,高可靠MySQL数据库服务,完善可靠的数据备份和恢复,完备的安全管理, 高效完善的监控, 提供多维度状态、性能、查询等数据的可视化等功能'
            },
            {
              key: '2',
              title: '云数据库JanusGraph',
              desc: '基于图模型，对图数据进行存储、操作和访问。即使没有专业的图论知识储备，也能轻松理解。它可以接受比实时查询更为复杂的分析需求，来挖掘图数据中的潜在价值'
            },
            {
              key: '3',
              title: '云数据库MongoDB',
              desc: '文档型NoSQL数据库服务，提供故障切换、容灾迁移、在线备份等一体化的解决方案'
            },
            {
              key: '4',
              title: '数据备份服务',
              desc: '为数据库提供连续数据保护、低成本的备份服务。备份中心基于分布式存储技术构建, 并实现跨地域多中心灾备, 支持加密存储, 保障备份数据安全可靠, 提供基于时间点的精确数据恢复等特性'
            },
            {
              key: '5',
              title: '数据传输服务',
              desc: '集数据迁移、数据同步、数据订阅于一体的数据传输服务, 支持增量、全量等数据同步方式. 灵活支持大数据的数据接入, 实时流式计算等场景'
            },
            {
              key: '6',
              title: '数据加密服务',
              desc: '通过虚拟化技术，帮助用户满足数据安全方面的监管和功能要求，保护云上业务数据的安全性及隐私性'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: 'ElasticSearch',
              desc: '开箱即用的云端 Elasticsearch 服务，集成安全、SQL、机器学习、告警等高级特性'
            },
            {
              key: '1',
              title: 'Redis',
              desc: '提供分布式 Redis 解决方案及主从版 Redis解决方案，支持故障自动迁移，数据安全可靠'
            },
            {
              key: '2',
              title: 'RabbitMQ',
              desc: '云上消息队列服务，支持广播、事务消息、消息路由、死信队列、优先级队列等特性，广泛应用于秒杀、流控、系统解耦等场景'
            },
            {
              key: '3',
              title: 'Zookeeper',
              desc: '分布式协调服务，可以在分布式系统中共享配置，协调锁资源，提供命名服务'
            },
            {
              key: '4',
              title: 'Kafka',
              desc: '高吞吐、高可用的消息中间件服务，适用于构建实时数据管道、流式数据处理、第三方解耦、流量削峰去谷等场景，具有大规模、高可靠、高并发访问、可扩展且完全托管的特点'
            },
            {
              key: '5',
              title: 'APIGateway',
              desc: '为开发者提供的高性能、高可用、高安全的API托管服务'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: 'CDN',
              desc: '内容分发网络（CDN）将源站内容分发至靠近用户的加速节点，使用户可以就近获得所需的内容，解决Internet网络拥挤的状况，提高用户访问的响应速度和成功率，从而提升您业务的使用体验'
            },
            {
              key: '1',
              title: 'DNS',
              desc: '智能DNS解析是指云解析可以根据用户端配置的DNS服务器所在的地区或机房，来判断用户的网络类型，实现对同一域名在不同网络环境解析出不同的IP地址，以保证访问者不因跨网访问造成网速慢'
            },
            {
              key: '2',
              title: '域名及负载AutoLB',
              desc: '将访问流量自动分发到多台云服务器、容器集群上，扩展应用系统对外的服务能力，实现更高水平的应用容错'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '视频直播',
              desc: '提供高并发、低延迟、高清流畅、安全可靠的端到端直播解决方案'
            },
            {
              key: '1',
              title: '短视频',
              desc: '集成了高清录制、视频拼接、特效渲染、美颜滤镜、传播分享的短视频能力'
            },
            {
              key: '2',
              title: '视频点播视频点播',
              desc: '为客户提供视频上传、自动化转码处理、媒资管理、分发加速的一站式视频点播媒体服务'
            },
            {
              key: '3',
              title: '媒体转码',
              desc: '为海量多媒体数据提供经济、高效、弹性的转码和音视频处理服务，支持丰富的转码格式，适合在PC、TV以及移动终端上播放，匹配多种商业场景'
            },
            {
              key: '4',
              title: '视频审核',
              desc: '提供视频质量审核、视频质量监控等一站式音视频质量管理服务，包括视频编码信息检测、关键指标实时监控、智能化数据分析、实时化异常告警和个性化数据报表配置等，驱动体验提升'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '代码安全审计',
              desc: '在项目发布、测试、部署时可以自动扫描代码安全性，其可通过后台来设置插件规则、漏洞知识库等信息'
            },
            {
              key: '1',
              title: '安全漏洞检测',
              desc: '为了方便业务线人员处理线上系统漏洞，而自主开发的一套修复流程。旨在快速解决线上安全问题，并保证业务的安全稳定运行。'
            }
          ]
        },
        {
          title: '',
          mulitrow: true,
          list: [
            {
              key: '0',
              title: '应用中心A-One',
              desc: '引入敏捷研发、持续集成、持续交付、DevOps等理念、支持公有云、私有云和混合云的一站式研发协同平台'
            },
            {
              key: '1',
              title: '云监控AutoCMP',
              desc: '为用户提供全方位的基础数据监控，无需配置，即可查看云服务器的性能视图及告警记录，实时掌握资源使用情况，保证应用稳定运行'
            },
            {
              key: '2',
              title: '云日志AutoLog',
              desc: '云日志AutoLog是一款为之家日志类数据提供的一站式服务平台。提供日志采集、历史日志查询、实时日志订阅、日志分析与监控等功能，帮助用户轻松应对日志类数据的监控、运营、运维等场景。'
            },
            {
              key: '3',
              title: '切图系统',
              desc: '切图系统（Dynamic Image System）用户根据配置不同url规则，切图系统实时动态的缩放不同规格的图片，全面提升海量图片的处理能力。'
            },
            {
              key: '4',
              title: '资产管理系统',
              desc: 'CMDB（Configuration Management Database）资产管理系统，为用户提供有关资产方面的全套数据。是一切应用和系统标准化、自动化、数据化和智能化的基石'
            },
            {
              key: '5',
              title: '运维平台',
              desc: '基于敏捷运维理念打造，实现批量执行CMD、模块、脚本，文件下发、定时任务，灰度执行、鉴权、审计；用一种灵活、高效及安全的方式，解放终端繁琐运维操作'
            },
            {
              key: '6',
              title: '性能测试',
              desc: '基于应用的性能测试能够将应用和性能测试绑定，形成基于应用的性能测试流水，同时性能测试基于容器的压力端水平伸缩架构，可模拟海量用户以及基于线上流量等真实的业务场景大容量、多协议、高并发压力测试'
            },
            {
              key: '7',
              title: 'Mock服务',
              desc: '一款高效、易用的接口Mock平台，为开发、产品、测试人员提供API管理及模拟服务'
            },
            {
              key: '8',
              title: '脚本工具',
              desc: '提供了脚本的管理、执行、结果展示的一站式公共服务，测试结果清晰明了， 结果趋势化显示，数据差异一目了然'
            },
            {
              key: '9',
              title: '代码覆盖率',
              desc: '针对Java项目的黑盒、白盒及全量、增量等不同维度的覆盖率统计'
            },
            {
              key: '10',
              title: '移动测试平台',
              desc: '移动测试（Mobile Testing）是为之家移动开发者提供真机测试服务的云平台，拥有大量热门机型，提供7x24全天候服务，帮助客户发现APP中的各类隐患，减少用户流失，提高APP质量和市场竞争力'
            },
            {
              key: '11',
              title: '质量度量',
              desc: '提供所有主流开发语言的代码扫描、扫描结果及报表展示及代码bug率统计'
            },
            {
              key: '12',
              title: '接口测试',
              desc: '零编码，通过配置即可进行接口测试测试数据统一维护'
            },
            {
              key: '13',
              title: '流量回放',
              desc: '基于线上流量回放的压测 更真实、更简单、更高效、使用成本低、随时可用等'
            }
          ]
        }
      ]
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1723,
    }
    window.trackPageView()
  },
  methods: {
    toggleTabs (index) {
      this.currentTabIndex = index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro-autocloud-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 544px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner2.jpg');
  background-repeat: no-repeat;
  background-position: -2px 0;
}
.autoclound-app {
  padding-top: 10px;
  background-color: #fff;
  margin-top: 40px;
}
.application-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
}
.application-title .word {
  font-size: 30px;
  font-family: 'PingFangSC-Medium';
  color: #20253F;
}
.application-title .lline {
  margin-right: 26px;
}
.application-title .rline {
  margin-left: 26px;
}
.application-title .line i {
  display: block;
  height: 1px;
  transform: scaleX(-1);
  background: #CACED5;
}
.application-title .line i:first-child {
  width: 71px;
}
.application-title .lline i:first-child {
  float: right;
}
.application-title .line i:last-child {
  width: 139px;
  margin-top: 11px;
}
.application-list {
  display: flex;
  background-color: #fff;
}
.application-list-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-family: 'PingFangSC-Regular';
}
.application-list-item .inner {
  margin: 47px 0 40px;
  padding: 38px 35px 45px;
  border-right: 1px solid rgba(151, 151, 151, .4);
}
.application-list-item:last-child {
  border-right: none;
}
.app-icon-wrap {
  height: 110px;
  display: flex;
  align-items: center;
}
.app-icon {
  display: block;
  margin: 0 auto;
  /* zoom: 0.4; */
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  /* transform-origin: top left;
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left; */
}
.app-icon0 {
  width: 186px;
  height: 126px;
  background-image: url('./../assets/images/_icon-app-0.png');
}
.app-icon1 {
  width: 216px;
  height: 216px;
  background-image: url('./../assets/images/_icon-app-1.png');
}
.app-icon2 {
  width: 221px;
  height: 221px;
  background-image: url('./../assets/images/_icon-app-2.png');
}
.app-name {
  margin-top: 30px;
  font-size: 22px;
  color: #20253F;
  text-align: center;
}
.app-intro {
  margin-top: 22px;
  font-size: 16px;
  color: #6F778F;
  line-height: 25px;
}
.hoverStyle {
  box-shadow: 9px 0 13px 0 rgba(139, 139, 139, 0.21);
  transition: box-shadow .6s;
}
.hoverStyle .inner {
  border-right: none;
}

.application-wrap {
  margin-bottom: -2px;
}
.application-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
}
.application-title .word {
  font-size: 30px;
  font-family: 'PingFangSC-Medium';
  color: #20253F;
}
.application-title .lline {
  margin-right: 26px;
}
.application-title .rline {
  margin-left: 26px;
}
.application-title .line i {
  display: block;
  height: 1px;
  transform: scaleX(-1);
  background: #CACED5;
}
.application-title .line i:first-child {
  width: 71px;
}
.application-title .lline i:first-child {
  float: right;
}
.application-title .line i:last-child {
  width: 139px;
  margin-top: 11px;
}
.tabs-filter {
  display: flex;
  justify-content: center;
  margin: -20px 30px 40px;
  border-bottom: 1px solid rgba(223, 219, 219, .7);
}
.tab-filter-item {
  width: 11%;
  padding-bottom: 26px;
  text-align: center;
  font-size: 22px;
  color: #20253F;
  cursor: pointer;
  font-family: 'PingFangSC-Regular';
}
.tab-filter-item .tabicon {
  display: block;
  margin: 0 auto;
  /* zoom: 0.4; */
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  position: relative;
  top: 10px;
  width: 98px;
  height: 98px;
}
.tab-filter-item .icon0 {
  background-image: url('./../assets/images/_icon-app-tab-0.png');
}
.tab-filter-item .icon1 {
  background-image: url('./../assets/images/_icon-app-tab-1.png');
}
.tab-filter-item .icon2 {
  background-image: url('./../assets/images/_icon-app-tab-2.png');
}
.tab-filter-item .icon3 {
  background-image: url('./../assets/images/_icon-app-tab-3.png');
}
.tab-filter-item .icon4 {
  background-image: url('./../assets/images/_icon-app-tab-4.png');
}
.tab-filter-item .icon5 {
  background-image: url('./../assets/images/_icon-app-tab-5.png');
}
.tab-filter-item .icon6 {
  background-image: url('./../assets/images/_icon-app-tab-6.png');
}
.tab-filter-item .icon7 {
  background-image: url('./../assets/images/_icon-app-tab-7.png');
}
.tab-filter-item:hover {
  color: #3A5FFF;
}
.tab-filter-item:hover .icon0,
.tab-filter-item.active .icon0 {
  background-image: url('./../assets/images/_icon-app-tab-active-0.png');
}
.tab-filter-item:hover .icon1,
.tab-filter-item.active .icon1 {
  background-image: url('./../assets/images/_icon-app-tab-active-1.png');
}
.tab-filter-item:hover .icon2,
.tab-filter-item.active .icon2 {
  background-image: url('./../assets/images/_icon-app-tab-active-2.png');
}
.tab-filter-item:hover .icon3,
.tab-filter-item.active .icon3 {
  background-image: url('./../assets/images/_icon-app-tab-active-3.png');
}
.tab-filter-item:hover .icon4,
.tab-filter-item.active .icon4 {
  background-image: url('./../assets/images/_icon-app-tab-active-4.png');
}
.tab-filter-item:hover .icon5,
.tab-filter-item.active .icon5 {
  background-image: url('./../assets/images/_icon-app-tab-active-5.png');
}
.tab-filter-item:hover .icon6,
.tab-filter-item.active .icon6 {
  background-image: url('./../assets/images/_icon-app-tab-active-6.png');
}
.tab-filter-item:hover .icon7,
.tab-filter-item.active .icon7 {
  background-image: url('./../assets/images/_icon-app-tab-active-7.png');
}
.tab-filter-item.active {
  position: relative;
  font-family: 'PingFangSC-Medium';
  font-size: 22px;
  color: #3A5FFF;
}
.tab-filter-item.active:after {
  display: inline-block;
  position: absolute;
  bottom: -1px;
  left: 50%;
  content: "";
  width: 17px;
  height: 3px;
  margin-left: -10px;
  background-color: #3A5FFF;
}
.tabs-content {
  /* height: 420px;
  overflow: hidden; */
}
.tabs-content .content-item {
  display: block;
  /* min-height: 400px; */
  /* background-color: #2382FA; */
}
.tabs-content .content-item img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/intro_autocloud.vue